/* eslint-disable camelcase */
import React, { useRef, useState } from 'react';
import { get_api_url } from '../../../utils/urls';
import { post_api } from '../../../redux/api_funcs';
import './moengage_export.css';

function MoengageExport() {
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageIsError, setMessageIsError] = useState(false);
  const fileInputRef = useRef(null);

  const openFilePicker = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const onFileSelected = (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = '';
    if (!file) {
      return;
    }
    setMessage('');
    setMessageIsError(false);
    setUploading(true);

    const formData = new FormData();
    formData.append('file', file);
    const url = get_api_url('/v2/cms_user/moengage_export', null, true);

    post_api(url, formData, true, 'formdata', null, 'blob')
      .then((res) => {
        const blob = new Blob([res.data], { type: 'text/csv' });
        const href = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = href;
        link.download = `moengage_export_${Date.now()}.csv`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => window.URL.revokeObjectURL(href), 100);
        setUploading(false);
        setMessage('Export downloaded.');
        setMessageIsError(false);
      })
      .catch((err) => {
        setUploading(false);
        setMessageIsError(true);
        const body = err?.response?.data;
        if (body instanceof Blob) {
          body
            .text()
            .then((text) => {
              try {
                setMessage(JSON.parse(text).reason || 'Export failed. Please try again.');
              } catch {
                setMessage('Export failed. Please try again.');
              }
            })
            .catch(() => setMessage('Export failed. Please try again.'));
        } else {
          setMessage(body?.reason || 'Export failed. Please try again.');
        }
      });
  };

  return (
    <div className="me-export">
      <h2 className="me-export-title">MoEngage user export</h2>
      <p className="me-export-hint">
        Upload a CSV with a student_uuid (or uuid / customer_id) column. Each value is looked up on
        MoEngage as a customer_id and the matched profile attributes are returned as a CSV. Up to
        500 UUIDs per file.
      </p>
      <div className="me-export-actions">
        <button
          type="button"
          className="me-export-btn me-export-btn-primary"
          onClick={openFilePicker}
          disabled={uploading}
        >
          {uploading ? 'Exporting…' : 'Upload CSV'}
        </button>
        <input
          ref={fileInputRef}
          type="file"
          accept=".csv"
          onChange={onFileSelected}
          style={{ display: 'none' }}
        />
      </div>
      {message ? (
        <p className={`me-export-msg${messageIsError ? ' me-export-msg-error' : ''}`}>{message}</p>
      ) : null}
    </div>
  );
}

export default MoengageExport;
